import { BLOCK_TYPE } from "contracts/enums/metrics";
import type { ContentBlock } from "contracts/report/blocks";
import { NumberField, TextArea, TextField } from "./editorFields";

export function BlockFields(props: {
  block: ContentBlock;
  onChange: (block: ContentBlock) => void;
}) {
  const set = (patch: Record<string, unknown>) =>
    props.onChange({ ...props.block, ...patch } as ContentBlock);

  if (
    props.block.type === BLOCK_TYPE.NOTE ||
    props.block.type === BLOCK_TYPE.RECOMMENDATION
  ) {
    return (
      <>
        <TextField
          label="Title"
          value={props.block.title ?? ""}
          onInput={(value) => set({ title: value || null })}
        />
        <TextArea
          label="Body"
          value={props.block.body}
          onInput={(value) => set({ body: value })}
        />
      </>
    );
  }

  if (props.block.type === BLOCK_TYPE.EVIDENCE) {
    return (
      <>
        <TextField
          label="Title"
          value={props.block.title ?? ""}
          onInput={(value) => set({ title: value || null })}
        />
        <TextField
          label="Source"
          value={props.block.source ?? ""}
          onInput={(value) => set({ source: value || null })}
        />
        <TextArea
          label="Evidence"
          value={props.block.body}
          onInput={(value) => set({ body: value })}
        />
      </>
    );
  }

  if (props.block.type === BLOCK_TYPE.RUBRIC_ITEM) {
    return (
      <>
        <TextField
          label="Label"
          value={props.block.label}
          onInput={(value) => set({ label: value })}
        />
        <NumberField
          label="Score"
          value={props.block.score}
          onInput={(value) => set({ score: value })}
        />
        <NumberField
          label="Max"
          value={props.block.maxScore}
          onInput={(value) => set({ maxScore: Math.max(1, value) })}
        />
        <TextArea
          label="Note"
          value={props.block.note ?? ""}
          onInput={(value) => set({ note: value || null })}
        />
      </>
    );
  }

  if (props.block.type === BLOCK_TYPE.SCORE_COMPONENT) {
    return (
      <>
        <TextField
          label="Label"
          value={props.block.label}
          onInput={(value) => set({ label: value })}
        />
        <NumberField
          label="Score"
          value={props.block.score}
          onInput={(value) => set({ score: value })}
        />
        <NumberField
          label="Weight"
          value={props.block.weight ?? 0}
          onInput={(value) => set({ weight: value })}
        />
        <TextArea
          label="Detail"
          value={props.block.detail ?? ""}
          onInput={(value) => set({ detail: value || null })}
        />
      </>
    );
  }

  return (
    <>
      <TextField
        label="Question"
        value={props.block.q}
        onInput={(value) => set({ q: value })}
      />
      <TextArea
        label="Answer"
        value={props.block.a}
        onInput={(value) => set({ a: value })}
      />
    </>
  );
}
